module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1AbrvwM/tc-custom/9781398457522.jpg?1705539731905",
      "alt": "This image is the cover for the book Tears Of Gold"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Tears Of Gold\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Tears of Gold is a thrilling tale of magic, action, fear, and danger. Four young boys set out on a camping trip in the west of Ireland in the 1960s, unknowingly pursued by an ancient evil that seeks the spirit of one of them. As they sit around their campfire, an old storyteller arrives and regales them with a tale of a magical land called Tir, filled with monsters, demons, heroes, and dragons. One man’s desperate search for redemption. As the old man tells his tale, the darkness around their camp seems to tighten, waiting for the opportunity to strike. The boys soon realize that not only are their own souls at risk, but the very soul of the world itself hangs in the balance.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Redmond Knowles\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Being born and bred in Dublin in the 1970s taught Redmond to start each day with a smile, as it improved the odds of going to bed with one. His mother’s deep sense of spiritualism combined with his father’s military discipline gave him a level head, which has served him well over the last thirty years in both the security and healthcare sectors. It was his maternal grandmother, however, who fed his imagination, as the fire she read and let him play with for endless hours was the birthplace of what would become Tears of Gold.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0